import { render, staticRenderFns } from "./feedbackType.vue?vue&type=template&id=b07c00fe&scoped=true"
import script from "./feedbackType.vue?vue&type=script&lang=js"
export * from "./feedbackType.vue?vue&type=script&lang=js"
import style0 from "./feedbackType.vue?vue&type=style&index=0&id=b07c00fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07c00fe",
  null
  
)

export default component.exports